// extracted by mini-css-extract-plugin
module.exports = {"grid":"infoBar_grid__22wzl","inputBoxA":"infoBar_inputBoxA__1eVus","inputBoxB":"infoBar_inputBoxB__aeV6F","date":"infoBar_date__1sEo9","children":"infoBar_children__3GT0j"};